import { ScannedByMethod } from "@/app/types/imported-profile/ImportedProfileAnalysisContext";
import { ImportedProfileListTab } from "@/app/types/imported-profile/ImportedProfileListTab";
import { ProspectPoolAvailability } from "@/app/types/prospect/ProspectPool";
import ProspectSourceLinkedin from "./ProspectSourceLinkedin";
import styles from "./ProspectSources.module.css";

type Props = {
  lang: string;
  isPlaceholder?: boolean;
  isLoading?: boolean;
  isSearching?: boolean;
  linkedinCount?: number;
  linkedinPotentialCount?: number;
  linkedinPotentialByMethod?: ScannedByMethod;
  linkedinFoundCount?: number;
  linkedinRejectedCount?: number;
  pool?: ProspectPoolAvailability;
  onOpenPool?: () => void;
  linkedinNeedUpdate?: boolean;
  linkedinHasUnanalyzed?: boolean;
  linkedinCanAnalyze?: boolean;
  linkedinPending?: boolean;
  canRun?: boolean;
  onLinkedinAnalyze?: () => void;
  onLinkedinViewImportedProfiles?: (tab?: ImportedProfileListTab) => void;
  onViewFound?: () => void;
};

export default function ProspectSources(props: Props) {
  const {
    lang,
    isPlaceholder = false,
    isLoading = false,
    linkedinCount = 0,
    linkedinPotentialCount = 0,
    linkedinPotentialByMethod,
    linkedinFoundCount = 0,
    linkedinRejectedCount = 0,
    pool,
    onOpenPool,
    linkedinNeedUpdate = false,
    linkedinHasUnanalyzed = false,
    linkedinCanAnalyze = true,
    linkedinPending = false,
    canRun = true,
    onLinkedinAnalyze,
    onLinkedinViewImportedProfiles,
    onViewFound,
  } = props;

  return (
    <div className={styles.grid}>
      <ProspectSourceLinkedin
        lang={lang}
        isPlaceholder={isPlaceholder}
        isLoading={isLoading}
        count={linkedinCount}
        potentialCount={linkedinPotentialByMethod?.ai ?? linkedinPotentialCount}
        keywordPotentialCount={linkedinPotentialByMethod?.keyword ?? 0}
        foundCount={linkedinFoundCount}
        rejectedCount={linkedinRejectedCount}
        pool={pool}
        onOpenPool={onOpenPool}
        needUpdate={linkedinNeedUpdate}
        hasUnanalyzed={linkedinHasUnanalyzed}
        canAnalyze={linkedinCanAnalyze}
        canRun={canRun}
        isAnalyzing={linkedinPending}
        onAnalyze={onLinkedinAnalyze}
        onViewImportedProfiles={onLinkedinViewImportedProfiles}
        onViewFound={onViewFound}
      />
    </div>
  );
}
